import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async index() {
    return useAsyncData('influencer-partnerships', () => this.call(`/spa/influencer/partnerships`), {
      lazy: true,
      deep: false,
    })
  }

  async store(data: any) {
    return await this.call(`/spa/influencer/partnerships`, {
      method: 'post',
      body: data,
    })
  }

  async update(id: number, data: any) {
    return await this.call(`/spa/influencer/partnerships/${id}`, {
      method: 'put',
      body: data,
    })
  }
}
